import { render, staticRenderFns } from "./CommonCard.vue?vue&type=template&id=2401b8cc&scoped=true&"
import script from "./CommonCard.vue?vue&type=script&lang=js&"
export * from "./CommonCard.vue?vue&type=script&lang=js&"
import style0 from "./CommonCard.vue?vue&type=style&index=0&id=2401b8cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2401b8cc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
